/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-12-04",
    versionChannel: "nightly",
    buildDate: "2024-12-04T00:06:48.518Z",
    commitHash: "18ece83c8c304e34a0b8e620af989bc17720c0dd",
};
